export function authDetails() {
    // return authorization header with jwt token
    let user = JSON.parse(sessionStorage.getItem('User'));

    if (user) {
        return user;
    } else {
        return {};
    }
} 


// WEBPACK FOOTER //
// ./src/helpers/auth-details.js